import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }           from '../api/api.service';
import { BookingsApiKeysModel } from './typings/bookings.api-keys';
import { ConfirmService }       from '../messages/confirm/confirm.service';
import { SecretKeysComponent }  from '../shared/components/secret-keys/secret-keys.component';

@Injectable({
  providedIn: 'root'
})
export class BookingApiSettingsService {
  public title = this.translateService.instant('COMPANY_SPACE.SETTINGS.PUBLIC_BOOKING_API');

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  activate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
        name: this.title
      }))
      .then(() => this.apiService.get('/company_integrations/enable_public_booking_api'));
  }

  deactivate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
        name: this.title
      }))
      .then(() => this.apiService.get('/company_integrations/disable_public_booking_api'));
  }

  generateApiKey () : Promise<any> {
    return this.apiService.get('/company_settings/generate_public_booking_api_key')
      .then(apiKeys => this.apiService.get('/company_settings/public_booking_api_company_id')
        .then(maskedCompanyId => {
          return {
            ...apiKeys,
            masked_company_id: maskedCompanyId.company_id
          };
        }))
      .then(( keys : BookingsApiKeysModel ) => {
        const modal =  this.modalService.open(SecretKeysComponent, {
          size: 'lg'
        });

        modal.componentInstance.keys = {
            apiKey   : keys.public_booking_api_key,
            companyId: keys.masked_company_id,
            secretKey: keys.public_booking_api_secret
          };

        return modal.result;
      });
  }

  get () : Promise<any> {
    return this.apiService.get('/company_settings')
      .then(settings => this.apiService.get('/company_settings/public_booking_api_company_id')
        .then(response => {
          settings.masked_company_id = response.company_id;

          return settings;
        }));
  }
}
